module.exports = __webpack_public_path__ + "static/media/logoGanaGana.a555a14c.png";